import React, { memo } from 'react';

import { Col } from 'antd';

import type IProduct from 'interfaces/IProduct';

interface IProps {
  product: IProduct;
}

const ProductDetails = ({ product }: IProps) => {
  return (
    <>
      <Col span={24}>
        <div className='flex max-sm:flex-col max-sm:text-center'>
          <div>
            <img
              className='block h-[115px] w-[115px] rounded-sm object-cover object-center max-sm:inline max-sm:h-[200px] max-sm:w-[200px]'
              src={product.image}
              alt='Preview'
            />
          </div>
          <div className='flex max-w-[600px] grow flex-col justify-center px-4 max-sm:px-0 max-sm:py-4'>
            <small className='mb-2'>#{product.id}</small>
            <strong>{product.title}</strong>
          </div>
        </div>
      </Col>
    </>
  );
};

export default memo(ProductDetails);
